import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import UserService from "services/UserService";
import TextInput from "components/Input/TextInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styled from "styled-components";
import { automationText } from "variables/MBM/geb";
import { controltypeData, controllistData } from "variables/MBM/lists/equipments";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { postGEBAutomation, putGEBAutomation, getGEBAutomationQRLaunch } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import CustomSwitch from "components/Input/CustomSwitch.js";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import EditButton from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Dialog from "@mui/material/Dialog";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import EquipmentsDialog from "./EquipmentsDialog";
import { automationtypeData, triggertypeData } from "variables/MBM/lists/geb";
import { controlmodeData } from "variables/MBM/lists/equipments";
import SweetAlert from "react-bootstrap-sweetalert";
import HelpIcon from '@mui/icons-material/Help';
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "react-data-table-component";
import uuid from "react-uuid";
import IntInputUn from "components/Input/IntInputUn";
import TextInputUn from "components/Input/TextInputUn";
import CustomList from "components/Input/CustomList"
import QRCode from "react-qr-code";
import PinInputUn from "components/Input/PinInputUn";
import GetAppIcon from "@mui/icons-material/GetApp";
import DateTimeInputUn from "components/Input/DateTimeInput";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput";
import { isNumber } from "lodash";

const saveSvgAsPng = require('save-svg-as-png');

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  icon: {
    left: "5px",
    top: "30px",
    width: "17px",
    height: "17px",
    position: "relative",
    verticalAlign: "middle",
    cursor: "pointer",
    color: "#3E8FC6",
  },
  editactionsbutton: {
    padding: "5px",
  }
}));
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.1rem;
  font-weight: 400;

`;
const EquipmentsLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  padding-top: 5px;
  margin-right: 8px;
`;
const EquipmentsDiv = styled.div`
  font-size: 14px;
  display: flex;
  margin-top: 16px;
  margin-bottom: 10px;
`;
const HelpLine = styled.p`
  text-align : left;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const ActionsDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 12px 10px;
  height: 32px;
  align-items: center;
`;
const ActionsTitle = styled.h1`
  font-size: 1.1rem;
  font-weight: 400;
`;
const ActionsValue = styled.h1`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  padding-top: 5px;
  margin-left: 10px;
`;
const QrDiv = styled.div`
  height: 64px;
  width: 64px;
  margin-top: 7px;
`;

const useStyles2 = makeStyles(styles);



function AutomationDialog(props) {
  const classes2 = useStyles2();
  const { closeModal, refetch, currentAutomation, fullpoints, equipments, workspace, schedulesData, scriptData } = props;
  const [alert, setAlert] = React.useState(null);
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupAccountListById, architecture } = appContext;

  const [name, setName] = useState(currentAutomation?.parameters.name || "");
  const [description, setDescription] = useState(currentAutomation?.parameters.description || "");
  const [syncciteos, setSyncciteos] = useState(currentAutomation?.parameters.syncciteos || false);
  const [actions, setActions] = useState(currentAutomation?.parameters.actions || []);
  const [triggers, setTriggers] = useState(currentAutomation?.parameters.triggers || []);
  const [automationtype, setAutomationtype] = useState(currentAutomation?.parameters.automationtype || "derogation");

  const [availablecontroltype, setAvailablecontroltype] = useState([]);

  const [currentAction, setCurrentAction] = useState("");
  const [currentTrigger, setCurrentTrigger] = useState("");

  const [openBadgers, setOpenBadgers] = useState(false);
  const [openEquipments, setOpenEquipments] = useState(false);
  const [openActions, setOpenActions] = useState(false);
  const [openTriggers, setOpenTriggers] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const classes = useStyles();

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleAutomationtypeChange = (event) => {
    setAutomationtype(event.target.value);
    setTriggers([]);
  };
  const handleSyncciteosChange = (e) => { setSyncciteos(!syncciteos); };

  const handleActiondescChange = (event, action) => {
    action.actiondesc = event.target.value;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.actiondesc = event.target.value;
    setActions(newactions);
  };

  const handleControltypeChange = (event, action) => {
    action.controltype = event.target.value;
    action.controltypedatatype = action.availablecontroltype.find((act) => act.id === event.target.value).type;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.controltype = event.target.value;
    actionmodif.controltypedatatype = action.availablecontroltype.find((act) => act.id === event.target.value).type;
    setActions(newactions);
  };

  const handleDefaultvalChange = (event, action) => {
    action.defaultval = event.target.value;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.defaultval = event.target.value;
    setActions(newactions);
  };

  const handleForcesaverChange = (action) => {
    const val = !action.forcesaver;
    action.forcesaver = val;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.forcesaver = val;
    setActions(newactions);
  };
  const handleChangescheduleChange = (action) => {
    const val = !action.changeschedule;
    action.changeschedule = val;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.changeschedule = val;
    setActions(newactions);
  };
  const handleChangeformulaChange = (action) => {
    const val = !action.changeformula;
    action.changeformula = val;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.changeformula = val;
    setActions(newactions);
  };

  const handleScheduleChange = (selected, action) => {
    action.schedule = selected?.id || "";
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.schedule = selected?.id || "";
    setActions(newactions);
  };

  const handleScriptChange = (selected, action) => {
    action.script = selected?.id || "";
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.script = selected?.id || "";
    setActions(newactions);
  };

  const handlePointsCheckedChange = (selected, action) => {
    console.log(selected);
    action.pointschecked = [...selected];
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.pointschecked = [...selected];
    setActions(newactions);
  };

  const handleFormulaChange = (event, action) => {
    action.formula = event.target.value;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.formula = event.target.value;
    setActions(newactions);
  };

  const handleControlmodeChange = (event, action) => {
    action.controlmode = event.target.value;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.controlmode = event.target.value;
    if (event.target.value === 0) //valeur constante
    {
      action.formula = "";
      actionmodif.formula = "";
    }
    else if (event.target.value === 1) //planning et formule
    {
      action.formula = "{schedule}";
      actionmodif.formula = "{schedule}";
    }
    else if (event.target.value === 2) //script
    {
      action.formula = "{script}";
      actionmodif.formula = "{script}";
    }
    setActions(newactions);
  };

  const handleTargetEquipmentChange = (selectedequipments, action) => {
    action.targetequipments = selectedequipments;
    let newactions = [...actions];
    let actionmodif = newactions.find((o) => o.uuid === action.uuid);
    actionmodif.targetequipments = selectedequipments;

    let availablecontroltypetmp = [];
    let firsteq = true;
    selectedequipments.forEach((eq) => {
      let eqpoints = fullpoints.filter((p) => p.equipment == eq.id && p.controlproperties?.controltype);
      if (firsteq) {
        availablecontroltypetmp = eqpoints.map((pt) => pt.controlproperties.controltype);
        firsteq = false;
      }
      else {
        availablecontroltypetmp = availablecontroltypetmp.filter((controltype) =>
          eqpoints.some((pt) => pt.controlproperties.controltype == controltype));
      }
    }
    );
    let availablecontroltypelist = controltypeData.filter((controltype) => availablecontroltypetmp.some((controltypeid) => controltypeid == controltype.id));
    action.availablecontroltype = availablecontroltypelist;
    actionmodif.availablecontroltype = availablecontroltypelist;

    if (action.controltype && !availablecontroltypelist.some((ctrl) => ctrl.id === action.controltype)) {
      action.controltype = "";
      actionmodif.controltype = "";

      action.controltypedatatype = "";
      actionmodif.controltypedatatype = "";

      action.defaultval = "";
      actionmodif.defaultval = "";
    }
    setActions(newactions);
  };

  const selectedSchedule = (schedule) => {
    let selected = schedulesData.find((obj) => obj.id == schedule);
    if (!selected)
      selected = "";
    return selected;
  };
  const selectedScript = (script) => {
    let selected = scriptData.find((obj) => obj.id == script);
    if (!selected)
      selected = "";
    return selected;
  };
  const isGroupInPath = (archi, idsearched, idgroup, inpath) => {
    let isinpath = false;
    if (idgroup === idsearched)
      return true;
    for (var i = 0; i < archi.length; i++) {  
      if (archi[i].id === idgroup) {
        return inpath;
      }
      else if (archi[i].children && archi[i].children.length > 0) {
        let found = inpath;
        if (archi[i].id === idsearched) {
          found = true;
        }
        isinpath = isGroupInPath(archi[i].children, idsearched, idgroup, found);
      }
      if(isinpath)
        break;
    }
    return isinpath;
  }



  const handleSubmit = (event) => {
    if (currentAutomation)
      updateAutomation(event);
    else
      createAutomation(event);
  };

  const hideAlert = () => {
    setAlert(null);
  };
  const getTooltipHelp = () => {
    const tooltipAlert = (
      <SweetAlert
        style={{
          fontSize: '14px',
          fontFamily: '"Source Sans Pro",sans-serif',
          color: ' #3c4858',
          display: "block", marginTop: "-50px", width: "25rem"
        }}
        title=""
        showConfirm={false}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
      >
        <div style={{ fontSize: "14px" }}>
          <p><b>Fonctions de la formule :</b></p>
          <HelpLine>{"{schedule} : la valeur du planning sur le créneau horaire"}</HelpLine>
          <HelpLine>{"{state} : la valeur actuelle du point piloté"}</HelpLine>
          <HelpLine>{"{AVG[points]} : la moyenne des valeurs des points liés"}</HelpLine>
          <HelpLine>{"{SUM[points]} : la somme des valeurs des points liés"}</HelpLine>
          <HelpLine>{"{MIN[points]} : le plus petite des valeurs des points liés"}</HelpLine>
          <HelpLine>{"{MAX[points]} : la plus grande des valeurs des points liés"}</HelpLine>
        </div>
      </SweetAlert>
    );
    setAlert(tooltipAlert);
  };

  useEffect(() => {
    let disabled = true;
    if (name)
      disabled = false;
    setButtonDisabled(disabled);
  }, [name]);



  const createAutomation = async (event) => {
    let newautomation = {
      parameters: {
        name,
        description,
        automationtype,
        actions,
        syncciteos,
        triggers,
      }
    }
    axios
      .post(
        postGEBAutomation(workspace.id),
        newautomation
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Automatisation créée");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const updateAutomation = async (event) => {
    let newautomationparameters = {
      ...currentAutomation.parameters,
      name,
      description,
      automationtype,
      actions,
      syncciteos,
      triggers,
    }
    axios
      .put(
        putGEBAutomation(currentAutomation.id, "parameters"),
        newautomationparameters
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Automatisation modifiée");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const [resetPaginationToggleChart, setResetPaginationToggleChart] = useState(false);
  /**ACTIONS */
  const addActionFunction = () => {
    let newactions = [...actions];
    let newaction = {};
    newaction.uuid = uuid();
    newaction.actiondesc = "Mettre une description";
    newaction.targetequipments = [];
    newaction.controltype = "";
    newaction.controltypedatatype = "";
    newaction.forcesaver = 1;
    newaction.controlmode = 0;
    newaction.changeschedule = 0;
    newaction.schedule = "";
    newaction.script = "";
    newaction.changeformula = 0;
    newaction.formula = "";
    newaction.defaultval = "";
    newactions.push(newaction);
    setActions(newactions);
  }

  const editEquipments = (action) => async () => {
    setCurrentAction(action);
    handleClickOpenEquipments();
  }
  const handleCloseEquipments = () => {
    setOpenEquipments(false);
  };
  const handleCloseActions = () => {
    setOpenActions(false);
  };
  const deleteActionFunction = (row) => async () => {
    let newactions = actions.filter((o) => o.uuid !== row.uuid);
    setActions(newactions);
  };
  const handleClickOpenEquipments = () => {
    setOpenEquipments(true);
  };
  const handleClickOpenActions = () => {
    setOpenActions(true);
  };

  const actionsColumns = [
    {
      name: automationText.selectedequipments,
      selector: (row) => row.targetequipments.length,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.targetequipments.length,
    },
    {
      name: automationText.controltype,
      selector: (row) => row.controltype,
      sortable: true,
      // maxWidth: "10rem",
      cell: (row) => row.controltype ? controltypeData.find((a) => a.id == row.controltype)?.name || "" : ""
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Supprimer l'action'">
              <EditButton
                onClick={deleteActionFunction(row)}
                color={"danger"}
                className={classes2.actionButton}
              >
                <DeleteIcon fontSize="large" />
              </EditButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ]

  const ExpandableComponent = (props) => {
    const { data } = props;
    let action = actions.find((o) => o.uuid === data.uuid);
    let actiondesc = action.actiondesc;
    let targetequipments = action.targetequipments;
    let controltype = action.controltype;
    let controltypedatatype = action.controltypedatatype;
    let forcesaver = action.forcesaver;
    let controlmode = action.controlmode;
    let changeschedule = action.changeschedule;
    let schedule = action.schedule;
    let script = action.script;
    let changeformula = action.changeformula;
    let formula = action.formula;
    let defaultval = action.defaultval;
    let availablecontroltype = action.availablecontroltype;
    let controltypedef = controltypeData.find((ctrl) => ctrl.id === controltype);
    let availablemodes = [];
    let multiplepointsbyeq = false;
    let pointstofilter = [];
    let pointschecked = action.pointschecked || [];
    if (controltypedef && controltypedef.type === 'list') {
      let firstpt = true;
      targetequipments.forEach((eq) => {
        let eqpoints = fullpoints.filter((p) => p.equipment == eq.id && p.controlproperties?.controls && p.controlproperties.controltype === controltype);
        pointstofilter = pointstofilter.concat(eqpoints);
        if (eqpoints.length > 1)
          multiplepointsbyeq = true;
        eqpoints.forEach((pt) => {
          if (firstpt) {
            availablemodes = [...pt.controlproperties.controls];
            firstpt = false;
          }
          else {
            let newavailablemodes = [...pt.controlproperties.controls];
            availablemodes = availablemodes.filter((mode) =>
              newavailablemodes.some((newmode) => mode.id === newmode.id));
          }
        });

      }
      );
      availablemodes.forEach((mode) => {
        mode.name = controllistData.find((cl) => cl.id === mode.id)?.name || "Mode non reconnu";
      });

    }
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ marginBottom: '1rem' }}>
          <div>
            <TextInputUn
              inputTitle={automationText.description}
              textInput={actiondesc}
              handleTextInputChange={(event) => handleActiondescChange(event, action)}
            />
          </div>
          <EquipmentsDiv>
            <EquipmentsLabel>
              {targetequipments.length + automationText.selectedequipments}
            </EquipmentsLabel>
            <Tooltip title="Choisir les équipements">
              <EditButton
                onClick={editEquipments(action)}
                color={"warning"}
                className={classes2.actionButton}
              >
                <EditIcon fontSize="large" />
              </EditButton>
            </Tooltip>
          </EquipmentsDiv>
          <div>
            <CustomSelect
              inputTitle={automationText.controltype}
              selectValue={controltype}
              handleSelectValueChange={(event) => handleControltypeChange(event, action)}
              data={availablecontroltype}
              isRequired
            />
          </div>
          {
            multiplepointsbyeq ?
              <>
                <EquipmentsLabel style={{ marginTop: "10px" }}>{automationText.filterpoints}</EquipmentsLabel>
                <CustomList
                  items={pointstofilter}
                  checked={pointschecked}
                  setChecked={(selected) => handlePointsCheckedChange(selected, action)}
                  maxHeight={"200px"}
                ></CustomList>
              </>
              : <> </>
          }
          {
            automationtype === 'controlrule' ?
              <>
                <div>
                  <CustomSwitch
                    style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                    inputTitle={automationText.forcesaver}
                    checkedState={forcesaver}
                    handleSwitchChange={(event) => handleForcesaverChange(action)}
                  />
                </div>
              </>
              : <> </>
          }
          {/* </GridItem>
        <GridItem xs={12} sm={12} md={5} lg={5}> */}

          <div>
            <CustomSelect
              inputTitle={"Mode de pilotage"}
              selectValue={controlmode}
              handleSelectValueChange={(event) => handleControlmodeChange(event, action)}
              data={controlmodeData}
            />
          </div>
          {controlmode === 1 ?
            <>
              <div>
                <CustomSwitch
                  style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                  inputTitle={automationText.changeschedule}
                  checkedState={changeschedule}
                  handleSwitchChange={(event) => handleChangescheduleChange(action)}
                />
              </div>
              {changeschedule ?
                <div>
                  <AutocompleteInputMeters
                    specialWidth={"97%"}
                    inputMargin={"1rem 0rem 0rem"}
                    inputTitle={"Planning"}
                    selected={selectedSchedule(schedule)}
                    list={schedulesData}
                    handleChange={(_, newValue) =>
                      handleScheduleChange(newValue, action)
                    }
                  />
                </div> : <></>
              }
              <div>
                <CustomSwitch
                  style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                  inputTitle={automationText.changeformula}
                  checkedState={changeformula}
                  handleSwitchChange={(event) => handleChangeformulaChange(action)}
                />
              </div>
              {changeformula ?
                <div>
                  <GridContainer>
                    <GridItem xs={11} sm={11} md={11} lg={11} className={"noPadding"}>
                      <TextInputUn
                        inputTitle={"Formule"}
                        textInput={formula}
                        handleTextInputChange={(event) => handleFormulaChange(event, action)}
                        multiline
                        rows={4}
                      />
                    </GridItem>
                    <GridItem xs={1} sm={1} md={1} lg={1}>
                      <HelpIcon className={classes.icon} onClick={() => getTooltipHelp()} />
                    </GridItem>
                  </GridContainer>
                </div> : <></>
              }

            </>
            : controlmode === 0 ?
              <>
                {
                  (controltypedef && controltypedef.type === 'int') ?
                    <IntInputUn
                      inputTitle={automationText.defaultval}
                      intInput={defaultval}
                      handleIntInputChange={(event) => handleDefaultvalChange(event, action)}
                    /> : (controltypedef && controltypedef.type === 'list') ? <CustomSelect
                      inputTitle={automationText.defaultval}
                      selectValue={defaultval}
                      handleSelectValueChange={(event) => handleDefaultvalChange(event, action)}
                      data={availablemodes}
                    /> : <></>
                }
              </> : controlmode === 2 ?
                <>
                  <div>
                    <AutocompleteInputMeters
                      specialWidth={"97%"}
                      inputMargin={"1rem 0rem 0rem"}
                      inputTitle={"Script"}
                      selected={selectedScript(script)}
                      list={scriptData}
                      handleChange={(_, newValue) =>
                        handleScriptChange(newValue, action)
                      }
                    />
                  </div>
                </> :
                <></>
          }


        </GridItem>
        <div style={{ height: "1.1rem" }}></div>
      </GridContainer >);
  };


  const subHeaderComponentMemoChart = useMemo(() => {
    const handleClearChart = () => {
    };
    return (
      <>
        <TableName>{automationText.actionstext}</TableName>
        <UploadButton type="button" onClick={handleClearChart}>
          <Tooltip title="Ajouter une action">
            <EditButton
              onClick={addActionFunction}
              color={"success"}
              className={classes2.actionButton}
              disabled={actions.length > 30}
            >
              <AddIcon fontSize="large" />
            </EditButton>
          </Tooltip>
        </UploadButton>
      </>
    );
  }, [actions]);


  /**TRIGGERS */
  const handleTargetBadgerChange = (selectedequipments, trigger) => {
    trigger.targetbadgers = selectedequipments;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.targetbadgers = selectedequipments;
    setActions(newtriggers);
  };
  const editBadgeuses = (trigger) => async () => {
    setCurrentTrigger(trigger);
    handleClickOpenBadgers();
  }
  const handleCloseBadgers = () => {
    setOpenBadgers(false);
  };
  const handleClickOpenBadgers = () => {
    setOpenBadgers(true);
  };
  const imageOptions = {
    scale: 5,
    encoderOptions: 1,
    backgroundColor: 'white',
  }
  const downloadPng = (uniqueid) => {
    var div1 = document.getElementById(uniqueid);
    if (div1)
      saveSvgAsPng.saveSvgAsPng(div1.getElementsByTagName('svg')[0], 'qrcode.png', imageOptions);
  };

  const handleTriggerdescChange = (event, trigger) => {
    trigger.triggerdesc = event.target.value;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerdesc = event.target.value;
    setTriggers(newtriggers);
  };
  const handleTriggertypeChange = (event, trigger) => {
    trigger.triggertype = event.target.value;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggertype = event.target.value;
    setTriggers(newtriggers);
  };
  const handleTriggerdatelimitChange = (trigger) => {
    const val = !trigger.triggerdatelimit;
    trigger.triggerdatelimit = val;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerdatelimit = val;
    setTriggers(newtriggers);
  };
  const handleTriggerqrcodepinChange = (trigger) => {
    const val = !trigger.triggerqrcodepin;
    trigger.triggerqrcodepin = val;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerqrcodepin = val;
    setTriggers(newtriggers);
  };
  const handleTriggercanstopChange = (trigger) => {
    const val = !trigger.triggercanstop;
    trigger.triggercanstop = val;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggercanstop = val;
    setTriggers(newtriggers);
  };
  const handleTriggerqrcodepinvalueChange = (event, trigger) => {
    trigger.triggerqrcodepinvalue = event.target.value;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerqrcodepinvalue = event.target.value;
    setTriggers(newtriggers);
  };
  const handleTriggerdatestartChange = (event, trigger) => {
    trigger.triggerdatestart = event.target.value;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerdatestart = event.target.value;
    setTriggers(newtriggers);
  };
  const handleTriggerdateendChange = (event, trigger) => {
    trigger.triggerdateend = event.target.value;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerdateend = event.target.value;
    setTriggers(newtriggers);
  };
  const handleTriggerchoosedurationChange = (trigger) => {
    const val = !trigger.triggerchooseduration;
    trigger.triggerchooseduration = val;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerchooseduration = val;
    setTriggers(newtriggers);
  };
  const handleTriggerdurationChange = (event, trigger) => {
    let dur = event.target.value;
    if(!isNumber(dur) || Number(dur)<1)
      dur = 1;
    trigger.triggerduration = dur;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerduration = dur;
    setTriggers(newtriggers);
  };
  const handleTriggerchoosedurationminChange = (event, trigger) => {
    trigger.triggerchoosedurationmin = event.target.value;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerchoosedurationmin = event.target.value;
    setTriggers(newtriggers);
  };
  const handleTriggerchoosedurationmaxChange = (event, trigger) => {
    trigger.triggerchoosedurationmax = event.target.value;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerchoosedurationmax = event.target.value;
    setTriggers(newtriggers);
  };
  const handleTriggerauthorizedbadgesChange = (value, trigger) => {
    trigger.triggerauthorizedbadges = value;
    let newtriggers = [...triggers];
    let triggermodif = newtriggers.find((o) => o.uuid === trigger.uuid);
    triggermodif.triggerauthorizedbadges = value;
    setTriggers(newtriggers);
  };

  const addTriggerFunction = () => {
    let newtriggers = [...triggers];
    let newtrigger = {};
    newtrigger.uuid = uuid();
    newtrigger.triggercanstop = false;
    newtrigger.triggerdesc = 'Mettre une description';
    newtrigger.triggertype = 'qrcode';
    newtrigger.targetbadgers = [];
    newtrigger.triggerdatelimit = '';
    newtrigger.triggerqrcodepin = '';
    newtrigger.triggerqrcodepinvalue = '';
    newtrigger.triggerdatestart = '';
    newtrigger.triggerdateend = '';
    newtrigger.triggerduration = '10';
    newtrigger.triggerchooseduration = '';
    newtrigger.triggerchoosedurationmin = '';
    newtrigger.triggerchoosedurationmax = '';
    newtrigger.triggerauthorizedbadges = '';
    newtriggers.push(newtrigger);
    setTriggers(newtriggers);
  }
  const deleteTriggerFunction = (row) => async () => {
    let newtriggers = triggers.filter((o) => o.uuid !== row.uuid);
    setTriggers(newtriggers);
  };
  const handleCloseTriggers = () => {
    setOpenTriggers(false);
  };

  const handleClickOpenTriggers = () => {
    setOpenTriggers(true);
  };
  const triggersColumns = [
    {
      name: automationText.triggertype,
      selector: (row) => row.triggertype,
      sortable: true,
      // maxWidth: "10rem",
      cell: (row) => row.triggertype ? triggertypeData.find((a) => a.id == row.triggertype)?.name || "" : ""
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Supprimer le déclencheur'">
              <EditButton
                onClick={deleteTriggerFunction(row)}
                color={"danger"}
                className={classes2.actionButton}
              >
                <DeleteIcon fontSize="large" />
              </EditButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ]

  const ExpandableComponentTriggers = (props) => {
    const { data } = props;
    let trigger = triggers.find((o) => o.uuid === data.uuid);
    let triggerdesc = trigger.triggerdesc;
    let triggertype = trigger.triggertype;
    let triggerdatelimit = trigger.triggerdatelimit;
    let triggerqrcodepin = trigger.triggerqrcodepin;
    let triggerqrcodepinvalue = trigger.triggerqrcodepinvalue;
    let triggerdatestart = trigger.triggerdatestart;
    let triggerdateend = trigger.triggerdateend;
    let triggerduration = trigger.triggerduration;
    let triggerchooseduration = trigger.triggerchooseduration;
    let triggerchoosedurationmin = trigger.triggerchoosedurationmin;
    let triggerchoosedurationmax = trigger.triggerchoosedurationmax;
    let triggerauthorizedbadges = trigger.triggerauthorizedbadges;
    let triggercanstop = trigger.triggercanstop;
    let targetbadgers = trigger.targetbadgers || [];
    let badgeslist = [];
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ marginBottom: '1rem' }}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12} style={{ marginBottom: '1rem' }}>
              <div>
                <TextInputUn
                  inputTitle={automationText.description}
                  textInput={triggerdesc}
                  handleTextInputChange={(event) => handleTriggerdescChange(event, trigger)}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={4} lg={4} style={{ marginBottom: '1rem' }}>
              <div>
                <CustomSelect
                  inputTitle={automationText.triggertype}
                  selectValue={triggertype}
                  handleSelectValueChange={(event) => handleTriggertypeChange(event, trigger)}
                  data={triggertypeData}
                  isRequired
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={8} lg={8} style={{ marginBottom: '1rem' }}>
              {
                triggertype === 'qrcode' ?
                  <div style={{ display: 'flex' }}>
                    <QrDiv id={'qr' + data.uuid}>
                      <QRCode
                        value={getGEBAutomationQRLaunch() + "/" + data.uuid}
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        viewBox={`0 0 256 256`}
                      />
                    </QrDiv>
                    <Tooltip title={automationText.triggerdownloadqr}>
                      <EditButton
                        onClick={() => downloadPng('qr' + data.uuid)}
                        color={"info"}
                        className={classes2.actionButton}
                        style={{ height: '32px', marginTop: '20px', marginLeft: '10px' }}
                      >
                        <GetAppIcon fontSize="large" />
                      </EditButton>
                    </Tooltip>
                  </div> :
                  <>
                    <EquipmentsDiv>
                      <EquipmentsLabel>
                        {targetbadgers.length + automationText.triggerselectedbadgers}
                      </EquipmentsLabel>
                      <Tooltip title="Choisir les badgeuses">
                        <EditButton
                          onClick={editBadgeuses(trigger)}
                          color={"warning"}
                          className={classes2.actionButton}
                        >
                          <EditIcon fontSize="large" />
                        </EditButton>
                      </Tooltip>
                    </EquipmentsDiv>
                  </>
              }
            </GridItem>
            {
              triggertype === 'badge' ?
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <div>
                    <AutocompleteTagsInput
                      specialWidth={"97%"}
                      inputMargin={"1rem 0rem 0rem"}
                      inputTitle={automationText.triggerauthorizedbadges}
                      selected={triggerauthorizedbadges}
                      list={badgeslist}
                      handleChange={(value) => handleTriggerauthorizedbadgesChange(value, trigger)}
                    />
                  </div>
                </GridItem> : <></>
            }
            <GridItem xs={12} sm={12} md={4} lg={4} style={{ marginBottom: '1rem' }}>
              <div>
                <CustomSwitch
                  style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                  inputTitle={automationText.triggerdatelimit}
                  checkedState={triggerdatelimit}
                  handleSwitchChange={(event) => handleTriggerdatelimitChange(trigger)}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={8} lg={8} style={{ marginBottom: '1rem' }}>
              {
                triggerdatelimit ?
                  <div style={{ display: 'flex' }}>
                    <DateTimeInputUn
                      inputTitle={automationText.triggerdatestart}
                      handleDateInputChange={(event) => handleTriggerdatestartChange(event, trigger)}
                      dateInput={triggerdatestart}
                    />
                    <DateTimeInputUn
                      inputTitle={automationText.triggerdateend}
                      handleDateInputChange={(event) => handleTriggerdateendChange(event, trigger)}
                      dateInput={triggerdateend}
                    />
                  </div>
                  :
                  <></>
              }
            </GridItem>
            {
              triggertype === 'qrcode' ?
                <>
                  <GridItem xs={12} sm={12} md={4} lg={4} style={{ marginBottom: '1rem' }}>
                    <div>
                      <CustomSwitch
                        style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                        inputTitle={automationText.triggerqrcodepin}
                        checkedState={triggerqrcodepin}
                        handleSwitchChange={(event) => handleTriggerqrcodepinChange(trigger)}
                      />
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={8} lg={8} style={{ marginBottom: '1rem' }}>
                    {
                      triggerqrcodepin ?
                        <>
                          <PinInputUn
                            inputTitle={automationText.triggerqrcodepinhelper}
                            handlePinInputChange={(event) => handleTriggerqrcodepinvalueChange(event, trigger)}
                            pinInput={triggerqrcodepinvalue}
                            length={4}
                          />
                        </>
                        :
                        <></>
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={12} style={{ marginBottom: '1rem' }}>
                    <div>
                      <CustomSwitch
                        style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                        inputTitle={automationText.triggercanstop}
                        checkedState={triggercanstop}
                        handleSwitchChange={(event) => handleTriggercanstopChange(trigger)}
                      />
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12} lg={12} style={{ marginBottom: '1rem' }}>
                    <div>
                      <IntInputUn
                        inputTitle={automationText.triggerduration}
                        handleIntInputChange={(event) => handleTriggerdurationChange(event, trigger)}
                        intInput={triggerduration}
                        min={1}
                      />
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4} lg={4} style={{ marginBottom: '1rem' }}>
                    <div>
                      <CustomSwitch
                        style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                        inputTitle={automationText.triggerchooseduration}
                        checkedState={triggerchooseduration}
                        handleSwitchChange={(event) => handleTriggerchoosedurationChange(trigger)}
                      />
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={8} lg={8} style={{ marginBottom: '1rem' }}>
                    {
                      triggerchooseduration ?
                        <div style={{ display: 'flex' }}>
                          <IntInputUn
                            inputTitle={automationText.triggerchoosedurationmin}
                            handleIntInputChange={(event) => handleTriggerchoosedurationminChange(event, trigger)}
                            intInput={triggerchoosedurationmin}
                          />
                          <IntInputUn
                            inputTitle={automationText.triggerchoosedurationmax}
                            handleIntInputChange={(event) => handleTriggerchoosedurationmaxChange(event, trigger)}
                            intInput={triggerchoosedurationmax}
                          />
                        </div>
                        :
                        <></>
                    }
                  </GridItem>
                </>
                : triggertype === 'badge' ?
                  <>
                    <GridItem xs={12} sm={12} md={12} lg={12} style={{ marginBottom: '1rem' }}>
                      <div>
                        <IntInputUn
                          inputTitle={automationText.triggerduration}
                          handleIntInputChange={(event) => handleTriggerdurationChange(event, trigger)}
                          intInput={triggerduration}
                        />
                      </div>
                    </GridItem>
                  </>
                  : <></>
            }
          </GridContainer >
        </GridItem >
        <div style={{ height: "1.1rem" }}></div>
      </GridContainer >);
  };


  const subHeaderComponentMemoChartTriggers = useMemo(() => {
    const handleClearChart = () => {
    };
    return (
      <>
        <TableName>{automationText.triggerstext}</TableName>
        <UploadButton type="button" onClick={handleClearChart}>
          <Tooltip title="Ajouter un déclencheur">
            <EditButton
              onClick={addTriggerFunction}
              color={"success"}
              className={classes2.actionButton}
              disabled={actions.length > 30}
            >
              <AddIcon fontSize="large" />
            </EditButton>
          </Tooltip>
        </UploadButton>
      </>
    );
  }, [triggers]);


  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={automationText.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
                isRequired
              />
            </div>
            <div>
              <TextInput
                inputTitle={automationText.description}
                textInput={description}
                multiline
                rows={2}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={automationText.automationtype}
                selectValue={automationtype}
                handleSelectValueChange={handleAutomationtypeChange}
                data={automationtypeData}
                isRequired
              />
            </div>
            {
              isGroupInPath(architecture,""+41604,""+workspace.idgroup,false) ?
                <>
                  <div>
                    <CustomSwitch
                      style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                      inputTitle={automationText.syncciteos}
                      checkedState={syncciteos}
                      handleSwitchChange={handleSyncciteosChange}
                    />
                  </div>
                </> : <></>
            }
            <ActionsDiv>
              {/* <ActionsTitle>{automationText.actions}</ActionsTitle> */}
              <Tooltip title={automationText.editactions}>
                <EditButton
                  onClick={handleClickOpenActions}
                  color={"warning"}
                  className={classes2.actionButton}
                >
                  <EditIcon fontSize="large" />
                </EditButton>
              </Tooltip>
              <ActionsValue>
                {actions.length + ' ' + automationText.actionscount}
              </ActionsValue>
            </ActionsDiv>
            {
              automationtype === 'derogation' ?
                <ActionsDiv>
                  {/* <ActionsTitle>{automationText.triggers}</ActionsTitle> */}
                  <Tooltip title={automationText.edittriggers}>
                    <EditButton
                      onClick={handleClickOpenTriggers}
                      color={"warning"}
                      className={classes2.actionButton}
                    >
                      <EditIcon fontSize="large" />
                    </EditButton>
                  </Tooltip>
                  <ActionsValue>
                    {triggers.length + ' ' + automationText.triggercount}
                  </ActionsValue>

                </ActionsDiv> : <></>
            }







          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
      <Dialog
        onClose={handleCloseEquipments}
        aria-labelledby="addMarket-dialog-title"
        fullWidth={true}
        maxWidth="md"
        open={openEquipments}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseEquipments}>
          Equipements concernés
        </CustomDialogTitle>
        <DialogContent dividers>
          <EquipmentsDialog
            closeModal={handleCloseEquipments}
            equipmentsData={equipments}
            setEquipments={handleTargetEquipmentChange}
            currentAction={currentAction}
          />
        </DialogContent>
        <DialogActions />
      </Dialog>
      <Dialog
        onClose={handleCloseBadgers}
        aria-labelledby="addMarket-dialog-title"
        fullWidth={true}
        maxWidth="md"
        open={openBadgers}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseBadgers}>
          Badgeuses concernées
        </CustomDialogTitle>
        <DialogContent dividers>
          <EquipmentsDialog
            closeModal={handleCloseBadgers}
            equipmentsData={equipments}
            setEquipments={handleTargetBadgerChange}
            currentTrigger={currentTrigger}
          />
        </DialogContent>
        <DialogActions />
      </Dialog>
      <Dialog
        onClose={handleCloseActions}
        aria-labelledby="addMarket-dialog-title"
        fullWidth={true}
        maxWidth="md"
        open={openActions}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseActions}>
          {automationText.editactions}
        </CustomDialogTitle>
        <DialogContent dividers>
          <DataTable
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            noDataComponent={<NoData>{"Aucune action"}</NoData>}
            noHeader={true}
            columns={actionsColumns}
            persistTableHead
            pagination
            subHeader
            data={actions}
            paginationComponentOptions={{
              noRowsPerPage: false,
              rowsPerPageText: "Lignes par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les lignes",
            }}
            defaultPageSize={10}
            filterable={true}

            manual={true}
            paginationResetDefaultPage={setResetPaginationToggleChart}
            subHeaderComponent={subHeaderComponentMemoChart}
            expandOnRowClicked
            expandableRows
            expandableRowDisabled={(row) => row.disabled}
            expandableRowsComponent={ExpandableComponent}
          />
        </DialogContent>
        <DialogActions />
      </Dialog>
      <Dialog
        onClose={handleCloseTriggers}
        aria-labelledby="addMarket-dialog-title"
        fullWidth={true}
        maxWidth="md"
        open={openTriggers}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseTriggers}>
          {automationText.edittriggers}
        </CustomDialogTitle>
        <DialogContent dividers>
          <DataTable
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            noDataComponent={<NoData>{"Aucun déclencheur"}</NoData>}
            noHeader={true}
            columns={triggersColumns}
            persistTableHead
            pagination
            subHeader
            data={triggers}
            paginationComponentOptions={{
              noRowsPerPage: false,
              rowsPerPageText: "Lignes par page",
              rangeSeparatorText: "sur",
              selectAllRowsItem: false,
              selectAllRowsItemText: "Selectionner toutes les lignes",
            }}
            defaultPageSize={10}
            filterable={true}

            manual={true}
            paginationResetDefaultPage={setResetPaginationToggleChart}
            subHeaderComponent={subHeaderComponentMemoChartTriggers}
            expandOnRowClicked
            expandableRows
            expandableRowDisabled={(row) => row.disabled}
            expandableRowsComponent={ExpandableComponentTriggers}
          />
        </DialogContent>
        <DialogActions />
      </Dialog>
      {alert}
    </>
  );
}

export default AutomationDialog;
